export class PedidoEmailContato {
    nome: string;
    email: string;
    adicionado: boolean;

    constructor(nome: string, email: string) {
        this.nome = nome;
        this.email = email;
        this.adicionado = false;
    }
}
